<!--
 * @Author: Tina Huang
 * @Date: 2022-07-18 14:16:55
 * @LastEditors: Tina Huang
 * @LastEditTime: 2024-01-16 12:46:38
 * @Description: 
-->
<template>
  <div id="app">
    <BindDialog />
    <Code />
    <router-view />
  </div>
</template>
<script>
import BindDialog from "./components/BindDialog.vue";
import Code from "./components/CodeDialog.vue";
export default {
  components: { Code, BindDialog },
};
</script>
<style>
#app {
  font-family: huangyou, monospace， sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
}
.lib-container {
  padding: 5vw;
  padding-top: 120px;
  min-height: 70vh;
}
</style>
